
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/dinners",
      function () {
        return require("private-next-pages/account/dinners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/dinners"])
      });
    }
  